


























































import {
  computed, defineComponent, reactive, ref, Ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import useDownloadReport from '@/useDownloadReport';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';
import useDelivery from '@/useDelivery';
import deliveriesTableOption from '@/table/report/csv/deliveries';
import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';

import getHubs from '@/gql/company/getHubs.gql';

const NOW = useFormat.date().computerShortDate();

const RawDeliveriesCSV = defineComponent({
  // components: {},
  setup() {
    const { me } = useAuth();
    const { router } = useRouter();
    const { getRawDataReport } = useDownloadReport();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();
    const { type, typeDisplay } = useDelivery();

    const filter = reactive({
      status: '',
      customerName: '',
      hub: undefined,
      destinationHub: undefined,
      hasDeliveryNote: undefined,
      deliveryNote: undefined,
      range: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
      deliveryDate: {
        from: undefined,
        to: undefined,
      },
      type: undefined,
    });

    function clearFilter() {
      filter.status = '';
      filter.customerName = '';
      filter.hub = undefined;
      // filter.range.from = undefined;
      filter.range.to = undefined;
      filter.deliveryDate.from = undefined;
      filter.deliveryDate.to = undefined;
      filter.type = undefined;
    }

    const computedDateInput = computed(() => ({
      from: filter.deliveryDate.from ? `${filter.deliveryDate.from} 00:00:00` : undefined,
      to: filter.deliveryDate.from ? `${filter.deliveryDate.to} 23:59:59` : undefined,
    }));

    const computedCreatedDateInput = computed(() => ({
      from: filter.range.from ? `${filter.range.from} 00:00:00` : undefined,
      to: filter.range.from ? `${filter.range.to} 23:59:59` : undefined,
    }));

    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        /* eslint-disable */
        ids: undefined,
        created_since: undefined,
        created_before: undefined,
        delivery_date_from: undefined,
        delivery_date_to: undefined,
        status: undefined,
        hub_id: undefined,
        area_id: undefined,
        driver_id: undefined,
        vehicle_id: undefined,
        type: undefined,
      };
      if (filter.status) vars.status = filter.status;
      if (filter.deliveryDate.from) {
        vars.delivery_date_from = computedDateInput.value.from;
        vars.delivery_date_to = computedDateInput.value.to;
      }
      if (filter.range.from) {
        vars.created_since = computedCreatedDateInput.value.from;
        vars.created_before = computedCreatedDateInput.value.to;
      }
      if (me.hub.hubType !== 'MAIN' || filter.hub) vars.hub_id = (filter.hub as any)?.id || me.hubId;
      if (filter.destinationHub) vars.destination_hub_id = (filter.destinationHub as any)?.id || undefined;
      if (filter.type) vars.type = filter.type;
      /* eslint-enable */
      return vars;
    });

    const getOrdersResult = (data: any) => data.deliveries;

    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    const totalItems = ref(0);
    function handlerFetchData(queryData: any) {
      totalItems.value = queryData.total;
    }
    function handleSelectAllItem($event: any[]) { selectedItemId.value = $event; }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    function clickRowHandler(row: any) {
      router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    }

    return {
      me,
      type,
      typeDisplay,

      clickRowHandler,
      getRawDataReport,
      translateDistanceType,
      distanceTypeToChipClass,

      clearFilter,
      filter,
      ordersVariable,
      getOrdersResult,
      selectedItemId,
      selectItem,

      getHubs,
      deliveriesTableOption,

      handlerFetchData,
      handleSelectAllItem,
      selectedAll,
    };
  },
});

export default RawDeliveriesCSV;
